import React,{useEffect} from "react";
import "./Tarh.css";
import config from "./../../services//config.json";
import { useContext } from "react";
import SimpleContext from "./../context/SimpleContext";
import { useHistory } from "react-router-dom";

const Tarhs = ({
  images,
  title,
  Description,
  DiscountGroup,
  prdcode,
  kfpVnDiscountId,
  step,
  imageLink
  

}) => {
  const context = useContext(SimpleContext);
  const history = useHistory();
  //برای هندل کردن ارور عکس ها
  const addDefaultSrc = (ev) => {
    ev.target.src = "/images/placeholder.jpg";
  };

  //رفتن به صفحه جزییات طرح ها
  const goToDetails = (title, kfpVnDiscountId,step) => {
    context.setsearchProducts({})
    context.setsearchBodyOfProduct({})
    context.setdiscountStep(step)
    let idD = kfpVnDiscountId;
    context.setTarhaTitle(title);
    history.push("/TarhDetails");
    context.search(0, "", kfpVnDiscountId,0,[],context.sort,0,0,0,context.searchBodyOfProduct);
    context.categories(0,[])
  };

  return (
    <div onClick={() => goToDetails(title, kfpVnDiscountId,step)}>
      <div className="top_tarh_Div">
        <div className="top_tarh_Div_ImgPlace">
          <img
            onError={addDefaultSrc}
            src={imageLink}
            alt="tarhdar"
            className="tarhdarImg"
          />
        </div>
        <div className="top_tarh_Div_NamePlace">
          <p>{title}</p>
        </div>
      </div>
      <div className="bottun_tarh_Div">
        {/* <div className="bottun_tarh_Div2"> */}
        {Description.split("\n").map((item, key) => {
          return <p key={key}>{item}</p>;
        })}
        {/* </div> */}
      </div>
    </div>
  );
};

export default Tarhs;
